export default {
    bank_name: 'ឈ្មោះ​​ធនាគារ',
    account_number: 'លេខគណនី',
    account_name: 'ឈ្មោះគណនី',
    amount: 'ចំនួនទឹកប្រាក់',
    popup_title: 'ដក​លុយ',
    popup_title_confirm: 'បញ្ជាក់ការដកប្រាក់',
};
